module.exports = "pegasus/assets/header-fall-pets-2.jpg";